// Author THQ
// Date 2025-03-28 11:22:41

class PpeApplyRecord {
constructor({
        id = null,
        applicant = '',
        applicantName = '',
        applyIdDept = '',
        deptManager = '',
        ehsManager = '',
        warehouseKeeper = '',
        applyReason = '',
        applyType = '',
        lastApplyDate = '',
        applyStartDate = '',
        applyEndDate = '',
        attachments = '',
        remark = '',
        workOrderCode = '',
        status = '',
        attachmentsList = ''}
= {}) {
    this.id = id;
    this.applicant = applicant;
    this.applicantName = applicantName;
    this.applyIdDept = applyIdDept;
    this.deptManager = deptManager;
    this.ehsManager = ehsManager;
    this.warehouseKeeper = warehouseKeeper;
    this.applyReason = applyReason;
    this.applyType = applyType;
    this.lastApplyDate = lastApplyDate;
    this.applyStartDate = applyStartDate;
    this.applyEndDate = applyEndDate;
    this.attachments = attachments;
    this.remark = remark;
    this.workOrderCode = workOrderCode;
    this.status = status;
    this.attachmentsList = attachmentsList;
}
}

function newEntity() {
return new PpeApplyRecord();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.ppe.ppeApplyRecord.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'workOrderCode',
        label: 'label.em.ppe.ppeApplyRecord.grid.workOrderCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'status',
        label: 'label.em.ppe.ppeApplyRecord.grid.status',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'statusName',
        label: 'label.em.ppe.ppeApplyRecord.grid.statusName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applyIdDept',
        label: 'label.em.ppe.ppeApplyRecord.grid.applyIdDept',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applyDeptName',
        label: 'label.em.ppe.ppeApplyRecord.grid.applyDeptName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applicantNumber',
        label: 'label.em.ppe.ppeApplyRecord.grid.applicantNumber',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applicantName',
        label: 'label.em.ppe.ppeApplyRecord.grid.applicantName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'deptManagerNumber',
        label: 'label.em.ppe.ppeApplyRecord.grid.deptManagerNumber',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'deptManagerName',
        label: 'label.em.ppe.ppeApplyRecord.grid.deptManagerName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ehsManagerNumber',
        label: 'label.em.ppe.ppeApplyRecord.grid.ehsManagerNumber',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ehsManagerName',
        label: 'label.em.ppe.ppeApplyRecord.grid.ehsManagerName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'warehouseKeeperNumber',
        label: 'label.em.ppe.ppeApplyRecord.grid.warehouseKeeperNumber',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'warehouseKeeperName',
        label: 'label.em.ppe.ppeApplyRecord.grid.warehouseKeeperName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applyReason',
        label: 'label.em.ppe.ppeApplyRecord.grid.applyReason',
        sortable: true,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'ppe_apply_reason'
                        }
        },
        {
        key: 'applyReasonName',
        label: 'label.em.ppe.ppeApplyRecord.grid.applyReasonName',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'lastApplyDate',
        label: 'label.em.ppe.ppeApplyRecord.grid.lastApplyDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applyStartDate',
        label: 'label.em.ppe.ppeApplyRecord.grid.applyStartDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applyEndDate',
        label: 'label.em.ppe.ppeApplyRecord.grid.applyEndDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.em.ppe.ppeApplyRecord.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'attachmentsList',
        label: 'label.em.ppe.ppeApplyRecord.grid.attachmentsList',
        sortable: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
                        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    applyIdDeptFilter : '',
    applyDeptNameFilter : '',
    applicantFilter : '',
    applicantNameFilter : '',
    deptManagerFilter : '',
    deptManagerNameFilter : '',
    ehsManagerFilter : '',
    warehouseKeeperFilter : '',
    applyReasonFilter : '',
    applyTypeFilter : '',
    lastApplyDateRteFilter : '',
    lastApplyDateLteFilter : '',
    applyStartDateRteFilter : '',
    applyStartDateLteFilter : '',
    applyEndDateRteFilter : '',
    applyEndDateLteFilter : '',
    workOrderCodeFilter : '',
    statusFilter : '',
    workflowQueryTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'applyDeptNameFilter',
        label: 'label.em.ppe.ppeApplyRecord.filter.applyDeptName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applicantNameFilter',
        label: 'label.em.ppe.ppeApplyRecord.filter.applicantName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'deptManagerNameFilter',
        label: 'label.em.ppe.ppeApplyRecord.filter.deptManagerName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applyReasonFilter',
        label: 'label.em.ppe.ppeApplyRecord.filter.applyReason',
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'ppe_apply_reason'
                }
        },
        {
        key: 'lastApplyDateRteFilter',
        label: 'label.em.ppe.ppeApplyRecord.filter.lastApplyDateRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lastApplyDateLteFilter',
        label: 'label.em.ppe.ppeApplyRecord.filter.lastApplyDateLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applyStartDateRteFilter',
        label: 'label.em.ppe.ppeApplyRecord.filter.applyStartDateRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applyStartDateLteFilter',
        label: 'label.em.ppe.ppeApplyRecord.filter.applyStartDateLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applyEndDateRteFilter',
        label: 'label.em.ppe.ppeApplyRecord.filter.applyEndDateRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applyEndDateLteFilter',
        label: 'label.em.ppe.ppeApplyRecord.filter.applyEndDateLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'workOrderCodeFilter',
        label: 'label.em.ppe.ppeApplyRecord.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.ppe.ppeApplyRecord.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'PpeApplyRecord',statusFilter:1}
        }
        },
];


    const entityFormConfigs = [
        {
        key: 'applicant',
        label: 'label.em.ppe.ppeApplyRecord.entity.applicant',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"applicantName":"name","applyIdDept":"deptId"}'
                }
        },
        {
        key: 'applicantName',
        label: 'label.em.ppe.ppeApplyRecord.entity.applicantName',
        sortable: true,
        disabled: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applyReason',
        label: 'label.em.ppe.ppeApplyRecord.entity.applyReason',
        sortable: true,
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'ppe_apply_reason'
                }
        },
        {
        key: 'lastApplyDate',
        label: 'label.em.ppe.ppeApplyRecord.entity.lastApplyDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'remark',
        label: 'label.em.ppe.ppeApplyRecord.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'attachmentsList',
        label: 'label.em.ppe.ppeApplyRecord.entity.attachments',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
            ,correspondingField: 'attachments'
                }
        }
]

export {PpeApplyRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
